import React from "react";
import { motion } from "framer-motion";
import { Form } from "react-bootstrap";

const SystemOtpSettings = () => {
  return (
    <motion.div
      className="card container py-3"
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
    >
      {/* TITLE */}
      <motion.h5
        className="fw-semibold mb-3 text-primary"
        initial={{ opacity: 0, x: -20 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 0.1 }}
      >
        OTP Settings
      </motion.h5>

      {/* FORM CARD */}
      <motion.div
        className="card shadow-sm border-0"
        initial={{ opacity: 0, scale: 0.97 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 0.2 }}
      >
        <div className="card-body">

          <Form>

            {/* OTP TYPE */}
            <div className="row mb-3 align-items-center">
              <div className="col-md-3">
                <Form.Label>OTP Type</Form.Label>
              </div>
              <div className="col-md-4">
                <Form.Select>
                  <option>----- Select -----</option>
                  <option>Email OTP</option>
                  <option>SMS OTP</option>
                  <option>Both</option>
                </Form.Select>
              </div>
            </div>

            {/* OTP DIGITS */}
            <div className="row mb-3 align-items-center">
              <div className="col-md-3">
                <Form.Label>OTP Digit Limit</Form.Label>
              </div>
              <div className="col-md-4">
                <Form.Select>
                  <option>----- Select -----</option>
                  <option>4 Digits</option>
                  <option>6 Digits</option>
                  <option>8 Digits</option>
                </Form.Select>
              </div>
            </div>

            {/* OTP EXPIRY */}
            <div className="row mb-3 align-items-center">
              <div className="col-md-3">
                <Form.Label>OTP Expire Time</Form.Label>
              </div>
              <div className="col-md-4">
                <Form.Select>
                  <option>----- Select -----</option>
                  <option>1 Minute</option>
                  <option>5 Minutes</option>
                  <option>10 Minutes</option>
                </Form.Select>
              </div>
            </div>

          </Form>
        </div>
      </motion.div>

      {/* FOOTER */}
      <motion.div
        className="d-flex justify-content-end gap-2 mt-4"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.3 }}
      >
        <motion.button
          whileTap={{ scale: 0.9 }}
          className="btn btn-outline-secondary"
        >
          Cancel
        </motion.button>

        <motion.button
          whileTap={{ scale: 0.9 }}
          className="btn btn-outline-success"
        >
          Save Changes
        </motion.button>
      </motion.div>
    </motion.div>
  );
};

export default SystemOtpSettings;